import React from 'react'
import { FaRupeeSign } from "react-icons/fa";
import Arrow_Icon from '../../assets/images/arrow_icon.png'  


export default function FinanceDataCard({results , setOpenFinance , setType}  ) {
  
  return (
    <div  style={{ backgroundColor : "white" , padding : "1% 2%" , borderRadius : "5px" , width: "60%" , cursor: "pointer"}} 
    // onClick={()=>setOpenFinance(true)}
    >
     <h4 className='is-size-5 wd_100' >Finance</h4>
       <div className='is-flex' style={{ gap : '0.5%'}}>
       <div style={{ backgroundColor : "#EAF0FF" , color : "#3a5aac" , borderRadius : "5px" , width : "25%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" , paddingTop : "2%"}} onClick={()=>{ setType('TCU') ; setOpenFinance(true)}}>
        <p className='is-size-7 is-flex is-align-items-center figtree-text'><span className='figtree-text' style={{width : '90%'}}>Total credit Utilized</span>
        <span >
        <img
               width='30%' 
              src={Arrow_Icon}
              // src\assets\images\bookings_png.png
              alt='vfnvf'
            />
            </span>
        </p>
        <p className='is-size-6'><FaRupeeSign/>{results.totalCreditUtilized}</p> 
      </div>
      <div style={{ backgroundColor : "#FFF3E8" , color : "#c89260" , borderRadius : "5px" , width : "25%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f"}} onClick={()=>{ setType('PR') ; setOpenFinance(true)}}>
        <p className='is-size-7 is-flex is-align-items-center figtree-text'><span  className='figtree-text' style={{width : '90%'}}>Pending Reconciliation</span>
        <span >
        <img   
              width='30%'            
              src={Arrow_Icon}
              // src\assets\images\bookings_png.png
              alt='vfnvf'
              style={{color : "#E87A1A" , filter: 'invert(64%) sepia(84%) saturate(1242%) hue-rotate(347deg) brightness(96%) contrast(93%)'}}
            />
            </span>
        </p>
        <p className='is-size-6'><FaRupeeSign/>{results.pendingReconciliation}</p> 
      </div> 
      <div style={{ backgroundColor : "#EBF5FF" ,color : "#629fdd", borderRadius : "5px" , width : "25%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,  paddingTop : "2%"}} onClick={()=>{ setType('UD') ; setOpenFinance(true)}}>
        <p className='is-size-7 is-flex is-align-items-center figtree-text'><span className='figtree-text' style={{width : '90%'}}>Upcoming dues</span>
        <span >
        <img   
              width='30%'             
              src={Arrow_Icon}
              alt='vfnvf'
              style={{color : "#2B6ED4" , filter: 'invert(32%) sepia(77%) saturate(1730%) hue-rotate(197deg) brightness(95%) contrast(96%)'}}
            />
            </span>
        </p>
        <p className='is-size-6'><FaRupeeSign/>{results.upcomingDue}</p> 
      </div> 
      <div style={{ backgroundColor : "#FFEDED" ,color : "#d46666", borderRadius : "5px" , width : "25%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,  paddingTop : "2%"}} onClick={()=>{ setType('OD') ; setOpenFinance(true)}}>
        <p className='is-size-7 is-flex is-align-items-center figtree-text'><span  className='figtree-text' style={{width : '90%'}}>Over dues</span>
        <span >
        <img   
               width='30%'           
              src={Arrow_Icon}
              alt='vfnvf'
              style={{color : "#ED4545" , filter: 'invert(36%) sepia(97%) saturate(7450%) hue-rotate(345deg) brightness(98%) contrast(95%)'}}
            />
            </span>
        </p>
        <p className='is-size-6'><FaRupeeSign/>{results.overdueAmount}</p> 
      </div> 
        <div style={{ backgroundColor : "#FFEDED" ,color : "#d46666", borderRadius : "5px" , width : "25%", padding : "0.5%" , textAlign : "center" , boxShadow: "3px 3px 10px #635f5f" ,  paddingTop : "2%"}} onClick={()=>{ setType('AH') ; setOpenFinance(true)}}>
        <p className='is-size-6 is-flex is-align-items-center figtree-text'><span  className='figtree-text' style={{width : '90%'}}>Accounting Error</span>
        <span >
        <img   
               width='30%'           
              src={Arrow_Icon}
              alt='vfnvf'
              style={{color : "#ED4545" , filter: 'invert(36%) sepia(97%) saturate(7450%) hue-rotate(345deg) brightness(98%) contrast(95%)'}}
            />
            </span>
        </p>
        {/* <p className='is-size-6'><FaRupeeSign/>{results.accountingHealth}</p>  */}
      </div> 
       </div>       
    </div>
  )
}


